module.exports = __webpack_public_path__ + "static/media/toggle-menu.9dc01b6e.svg";